import { identifierToCoords, parseCellType } from "@utils";
/** possible patterns:
 * string, num/empty, ....
 * string, string, num/empty, ....
 * string, string, string, num/empty, ....
 */

export const autoBreakdownSearch = (
  area,
  titleColumnsLength,
  tags,
  maxWorkTypeLength
) => {
  const { data } = area;
  const mergeCells = Object.keys(area.mergeCells).map((x) => [
    ...identifierToCoords(x),
    ...area.mergeCells[x],
  ]);

  let modules = [],
    workTypes = [];

  let firstNumberCol = Infinity;
  let lastNumberCol = 0;
  data.forEach((row) => {
    const types = row.map((col) => parseCellType(col));

    const numberCol = types.indexOf("number");
    const numberCol2 = types.lastIndexOf("number");
    if (numberCol > 0 && numberCol < firstNumberCol) firstNumberCol = numberCol;
    if (numberCol > 0 && numberCol2 > lastNumberCol) lastNumberCol = numberCol2;
  });

  const takenSystems = [];
  if (firstNumberCol !== Infinity)
    [...Array(lastNumberCol - firstNumberCol + 1).keys()].forEach((y) => {
      const col = y + firstNumberCol;
      let title = data.find(
        (row, i) =>
          parseCellType(row[col]) === "string" &&
          !mergeCells.find(
            (m) =>
              i >= m[1] &&
              i <= m[1] + m[3] - 1 &&
              col >= m[0] &&
              col <= m[0] + m[2] - 1
          )
      )?.[col];

      //@todo??: find duplicates and use min-max setting
      if (title) {
        title = title.slice(0, maxWorkTypeLength).replace(/\s*$/, "");
        const f = tags.find(
          (t) =>
            title.toLowerCase() === t.name.toLowerCase() &&
            !takenSystems.includes(t.name)
        );

        if (
          workTypes.find((s) => s.name.toLowerCase() === title.toLowerCase())
        ) {
          workTypes.push({ name: "", column: col, columnMax: -1 });
          return;
        }

        if (f) {
          workTypes.push({
            id: f.id,
            name: f.name,
            column: col,
            columnMax: -1,
          });
          takenSystems.push(f.name);
        } else workTypes.push({ name: title, column: col, columnMax: -1 });
      } else workTypes.push({ name: "", column: col, columnMax: -1 });
    });

  // modules = JSON.parse("[{\"name\":\"PART 1 - USER PORTAL\",\"x\":0,\"y\":0,\"type\":\"section\"},{\"name\":\"SYSTEM CORE\",\"x\":0,\"y\":2,\"type\":\"module\"},{\"name\":\"Environment, architeture, database setup\",\"x\":0,\"y\":3,\"type\":\"feature\"},{\"name\":\"AUTHENTICATION\",\"x\":0,\"y\":5,\"type\":\"module\"},{\"name\":\"Sign in\",\"x\":0,\"y\":6,\"type\":\"feature\"},{\"name\":\"Password recovery (forgot / reset)\",\"x\":0,\"y\":7,\"type\":\"feature\"},{\"name\":\"USER PROFILE\",\"x\":0,\"y\":9,\"type\":\"module\"},{\"name\":\"Customer profile\",\"x\":0,\"y\":10,\"type\":\"feature\"},{\"name\":\"Change password\",\"x\":0,\"y\":11,\"type\":\"feature\"},{\"name\":\"PARTS CATALOG\",\"x\":0,\"y\":13,\"type\":\"module\"},{\"name\":\"Search & selection of compressor and its specification\",\"x\":0,\"y\":14,\"type\":\"feature\"},{\"name\":\"List of available parts\",\"x\":0,\"y\":15,\"type\":\"feature\"},{\"name\":\"Filters\",\"x\":0,\"y\":16,\"type\":\"feature\"},{\"name\":\"Interactive 3D Drawings of parts\",\"x\":0,\"y\":17,\"type\":\"feature\"},{\"name\":\"Parts details\",\"x\":0,\"y\":18,\"type\":\"feature\"},{\"name\":\"ORDERS\",\"x\":0,\"y\":20,\"type\":\"module\"},{\"name\":\"Creating a PO\",\"x\":0,\"y\":21,\"type\":\"feature\"},{\"name\":\"PO - PDF generation\",\"x\":0,\"y\":22,\"type\":\"feature\"},{\"name\":\"History of POs / orders\",\"x\":0,\"y\":23,\"type\":\"feature\"},{\"name\":\"PO details\",\"x\":0,\"y\":24,\"type\":\"feature\"},{\"name\":\"History - Filters\",\"x\":0,\"y\":25,\"type\":\"feature\"},{\"name\":\"OVERHAUL\",\"x\":0,\"y\":27,\"type\":\"module\"},{\"name\":\"Overhaul materials and instructions for compressors & parts\",\"x\":0,\"y\":28,\"type\":\"feature\"},{\"name\":\"NOTIFICATIONS\",\"x\":0,\"y\":30,\"type\":\"module\"},{\"name\":\"Notifications\",\"x\":0,\"y\":31,\"type\":\"feature\"},{\"name\":\"PART 2 - MAYEKAWA STAFF PORTAL\",\"x\":0,\"y\":33,\"type\":\"section\"},{\"name\":\"USER PROFILE\",\"x\":0,\"y\":35,\"type\":\"module\"},{\"name\":\"User profile\",\"x\":0,\"y\":36,\"type\":\"feature\"}]");
  return {
    modules,
    workTypes,
    titleColumnsLength,
  };
};
